import { Typography } from '@eventbrite/marmalade';
import classNames from 'classnames';
import React, { Suspense } from 'react';
import { ContentSkeleton } from './ContentSkeleton';
import './RelatedEventsSection.scss';

export type RelatedEventsSectionsProps = React.PropsWithChildren<{
    className?: string;
    title: React.ReactNode;
}>;

export function RelatedEventsSection({
    title,
    children,
    className,
    ...props
}: RelatedEventsSectionsProps) {
    return (
        <section
            className={classNames(className, 'related-events-section')}
            {...props}
        >
            <header>
                <Typography variant="heading-sm" className="title">
                    {title}
                </Typography>
            </header>
            <section>
                <Suspense fallback={<ContentSkeleton />}>{children}</Suspense>
            </section>
        </section>
    );
}
